import { ComponentSchema } from '@rengular/network-context';

export interface TextBoxLd extends ComponentSchema {
  '@type': 'Textbox';
  text: string;
}
